import { type VotingRegion, useVotingRegion } from './useVotingRegion.js'
import { persistent } from '../constants/index.js'
import { useAppCtx, useContentQuery } from '../ctx.js'

export type Contestants = {
  id: number
  song: string
  name: string
  ddi: string
  votingRegion: any
  round: string
  image: { src: string }
  thankYouVideos: {
    id: string
    src: string
    hls?: string
  }[]
  storyThankYouVideo: {
    id: string
    src: string
    hls?: string
  }
}[]

export const useLive = (): {
  id?: number
  loading: boolean
  contestants: Contestants
  title: string
  year?: string
  description: string
  name: string
  sequence: string
  round: { id: number; name: string }
  rounds: {
    [key: string]: {
      preShowtime: string
      showtime: string
    }
  }
  isVoting?: boolean
  canVote?: boolean
  countdown?: number
  votingRegion: VotingRegion
} => {
  const [votingRegion] = useVotingRegion()
  const ctx = useAppCtx()

  if (ctx.sequence) {
    const { data = {}, loading } = useContentQuery('preview', ctx.sequence)
    const res = {
      loading,
      ...data,
      votingRegion,
    }

    if (ctx.contestant && !loading) {
      const index = res.contestants.findIndex(
        ({ id }: any) => id === ctx.contestant,
      )
      if (index > 0) {
        const swap = res.contestants[0]
        res.contestants[0] = res.contestants[index]
        res.contestants[index] = swap
      }
      res.isVoting = true
    }

    return res
  }

  const { data = {}, loading } = useContentQuery(
    votingRegion.loading ? null : 'sequence',
    votingRegion.scenario?.id,
    persistent,
  )

  // get the index of object with name = "final"
  const index = data?.rounds?.findIndex((item: any) => item.name === 'final')

  if (index > -1) {
    data.year = new Date(data.rounds[index].showtime).getFullYear()
  }

  return {
    loading,
    ...data,
    votingRegion,
  }
}
